<script setup lang="ts">
import ReceiptModelSelect from '~/ui-blocks/Formalization/blocks/paymentModel/receiptModelSelect/ReceiptModelSelect.vue'

defineProps<{
  options: string[]
  modelValue: string
  disabled: boolean
  readonly: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [code: string]
}>()

const { t } = useI18n()
</script>

<template>
  <section
    class="flex flex-col gap-4"
    aria-labelledby="receipt-model-section-title"
  >
    <h3 id="receipt-model-section-title" class="receipt-model__section-title">
      {{ t('receipt-model.layout.model_section.title') }}
    </h3>

    <div class="flex flex-col gap-1">
      <ReceiptModelSelect
        id="receipt-model-select"
        :options="options"
        :model-value="modelValue"
        :disabled="disabled"
        :readonly="readonly"
        @update:model-value="emit('update:modelValue', $event)"
      />
      <span class="fonts-body-small-regular text-neutral-low-light">
        {{ t('receipt-model.layout.model_section.helper') }}
      </span>
    </div>
  </section>
</template>
